<template>
  <div class="item">
    <div class="icon">
      <VIcon :color="iconColor" small>
        {{ icon }}
      </VIcon>
    </div>
    <div class="text">{{ formattedDescription }}</div>
  </div>
</template>
<script>
export default {
  name: 'Item',
  props: {
    description: {
      type: String,
      required: true
    },
    isBool: {
      type: Boolean,
      required: false,
      default: false
    },
    isCount: {
      type: Boolean,
      required: false,
      default: false
    },
    isDays: {
      type: Boolean,
      required: false,
      default: false
    },
    code: {
      type: String,
      required: false
    },
    planInfo: {
      type: [String, Number, Boolean],
      required: false
    },
    planId: {
      type: Number,
      required: false
    }
  },
  computed: {
    formattedDescription() {
      const isBool = typeof this.planInfo === 'boolean' || this.isBool;

      if (this.isCount) {
        return this.planInfo ? `${String(this.planInfo).padStart(2, '0')} Ano(s) de ${this.description.toLowerCase()}` : `${this.description} ilimitado*`;
      }

      if (!isBool) {
        if (!this.planInfo) {
          return `Sem limite de ${this.description.toLowerCase()}`;
        }
        return `${String(this.planInfo).padStart(2, '0')} ${this.description}`;
      }

      return this.description;
    },
    icon() {
      if (!this.planInfo && this.isBool) return 'mdi-close-thick';

      if (this.isCount || this.code === 'full_time_support') {
        return 'mdi-check-bold';
      }

      const isBool = typeof this.planInfo === 'boolean';

      if (isBool) {
        return this.planInfo ? 'mdi-check-bold' : 'mdi-close-thick';
      }

      return 'mdi-check-bold';
    },
    iconColor() {
      if (!this.planInfo && this.isBool) return 'error';

      if (this.isCount || this.code === 'full_time_support') {
        return 'primary';
      }

      const isBool = typeof this.planInfo === 'boolean';

      if (isBool) {
        return this.planInfo ? '#48b38b' : 'error';
      }

      return '#48b38b';
    }
  }
};
</script>
